module.exports = __webpack_public_path__ + "img/Logo_black.bc4ba9d5.png";